import {
  Box,
  Button,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { ArrowLeft } from "lucide-react";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';

// Placeholder data — will be replaced by a GET API response
const ROOM_DATA = {
  roomName: "標準單人房",
  roomQuantity: "5",
  acceptedPetType: "貓咪，狗狗",
  acceptedPetQuantity: "1",
  roomDimensions: "3尺 x 2尺 x 2尺",
  roomPhotos: ["/icons/hotelPaw.png", "/icons/hotelPaw.png", "/icons/hotelPaw.png"],
  roomDesc: "寬敞舒適的單人房間，配備空調及基本設施。",
  weekdayPrice: "$200",
  weekendPrice: "$250",
  freeCancelDeadline: "入住日前 7 天或以上",
  lateCancelFee: "第一晚房費",
};

const YES_NO_PAIRS = [
  [
    { labelKey: "Heating24hLabel", value: "是" },
    { labelKey: "AdditionalFeeLabel", value: "$50" },
  ],
  [
    { labelKey: "PetPhotosVideosLabel", value: "是" },
    { labelKey: "CustomSnacksLabel", value: "否" },
  ],
  [
    { labelKey: "Ventilation24hLabel", value: "是" },
    { labelKey: "DailyDisinfectionLabel", value: "是" },
  ],
  [
    { labelKey: "DailyInteractionLabel", value: "是" },
    { labelKey: "CustomRequestsLabel", value: "否" },
  ],
  [
    { labelKey: "HasWindowLabel", value: "是" },
    { labelKey: "LateCheckoutLabel", value: "是" },
  ],
];

const PROMOTION_DATA = "早鳥優惠 - 適用於提前7日或以上預定的訂單，享9折優惠";

const HotelAdd_YOverview = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const isMobile = useMediaQuery("(max-width:950px)");

  const rowLabelSx = { fontSize: isMobile ? "12px" : "13px", color: "#999", mb: 0.5 };
  const rowValueSx = { fontWeight: "600", fontSize: isMobile ? "14px" : "16px", color: "#000" };

  const pageStyle = {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
    backgroundColor: "#F5F5F5",
  };

  const contentStyle = {
    flex: "1 0 auto",
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    padding: isMobile ? "100px 20px 60px" : "120px 80px 80px",
    maxWidth: "1600px",
    width: "100%",
  };

  const EditLink = () => (
    <Button
      onClick={() => navigate("/hotel/add/room-info-1")}
      sx={{
        alignSelf: "flex-start",
        color: "#31BACD",
        textTransform: "none",
        fontSize: isMobile ? "13px" : "14px",
        textDecoration: "underline",
        minWidth: "auto",
        padding: 0,
        mt: 0.5,
      }}
    >
      {t('Edit')}
    </Button>
  );

  const ReviewRow = ({ labelKey, value }) => (
    <Box sx={{ padding: "16px 0", borderBottom: "1px solid #E0E0E0" }}>
      <Typography sx={rowLabelSx}>{t(labelKey)}</Typography>
      <Typography sx={rowValueSx}>{value}</Typography>
      <EditLink />
    </Box>
  );

  return (
    <div style={pageStyle}>
      <Navbar />
      <div style={contentStyle}>

        <Box sx={{ width: isMobile ? "100%" : "60%", mx: "auto", display: "flex", flexDirection: "column" }}>
          {/* Heading */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 3 }}>
            <Button
              onClick={() => navigate(-1)}
              sx={{
                minWidth: "auto",
                width: isMobile ? "36px" : "44px",
                height: isMobile ? "36px" : "44px",
                borderRadius: "50%",
                backgroundColor: "#31BACD",
                color: "#fff",
                padding: 0,
                "&:hover": { opacity: 0.85, backgroundColor: "#31BACD" },
              }}
            >
              <ArrowLeft size={isMobile ? 18 : 22} />
            </Button>
            <Typography sx={{ fontWeight: "bold", fontSize: isMobile ? "20px" : "24px", color: "#000" }}>
              {t('ReviewInfoTitle')}
            </Typography>
            <Box
              sx={{
                backgroundColor: "#FFE0B2",
                color: "#E65100",
                fontSize: isMobile ? "11px" : "12px",
                fontWeight: "600",
                borderRadius: "6px",
                padding: "3px 10px",
              }}
            >
              {t('NotYetSubmittedBadge')}
            </Box>
          </Box>

          <Box sx={{ width: "100%" }}>
            <Box sx={{ display: "flex", gap: 3, padding: "16px 0", borderBottom: "1px solid #E0E0E0" }}>
              <Box sx={{ flex: 1 }}>
                <Typography sx={rowLabelSx}>{t('RoomNameLabel')}</Typography>
                <Typography sx={rowValueSx}>{ROOM_DATA.roomName}</Typography>
              </Box>
              <Box sx={{ flex: 1 }}>
                <Typography sx={rowLabelSx}>{t('RoomQuantityLabel')}</Typography>
                <Typography sx={rowValueSx}>{ROOM_DATA.roomQuantity}</Typography>
              </Box>
              <EditLink />
            </Box>

            <Box sx={{ display: "flex", gap: 3, padding: "16px 0", borderBottom: "1px solid #E0E0E0" }}>
              <Box sx={{ flex: 1 }}>
                <Typography sx={rowLabelSx}>{t('AcceptedPetTypeLabel')}</Typography>
                <Typography sx={rowValueSx}>{ROOM_DATA.acceptedPetType}</Typography>
              </Box>
              <Box sx={{ flex: 1 }}>
                <Typography sx={rowLabelSx}>{t('AcceptedPetQuantityLabel')}</Typography>
                <Typography sx={rowValueSx}>{ROOM_DATA.acceptedPetQuantity}</Typography>
              </Box>
              <EditLink />
            </Box>

            <ReviewRow labelKey="RoomDimensionsLabel" value={ROOM_DATA.roomDimensions} />

            <Box sx={{ padding: "16px 0", borderBottom: "1px solid #E0E0E0" }}>
              <Typography sx={rowLabelSx}>{t('RoomPhotosLabel')}</Typography>
              <Box sx={{ display: "flex", gap: 1.5, mb: 0.5 }}>
                {ROOM_DATA.roomPhotos.map((src, i) => (
                  <Box
                    key={i}
                    component="img"
                    src={src}
                    alt=""
                    sx={{
                      width: isMobile ? "70px" : "90px",
                      height: isMobile ? "70px" : "90px",
                      borderRadius: "8px",
                      objectFit: "cover",
                      border: "1px solid #E0E0E0",
                      backgroundColor: "#F5F5F5",
                    }}
                  />
                ))}
              </Box>
              <EditLink />
            </Box>

            <ReviewRow labelKey="RoomDescLabel" value={ROOM_DATA.roomDesc} />

            <Box sx={{ display: "flex", gap: 3, padding: "16px 0", borderBottom: "1px solid #E0E0E0" }}>
              <Box sx={{ flex: 1 }}>
                <Typography sx={rowLabelSx}>{t('WeekdayPriceLabel')}</Typography>
                <Typography sx={rowValueSx}>{ROOM_DATA.weekdayPrice}</Typography>
              </Box>
              <Box sx={{ flex: 1 }}>
                <Typography sx={rowLabelSx}>{t('WeekendPriceLabel')}</Typography>
                <Typography sx={rowValueSx}>{ROOM_DATA.weekendPrice}</Typography>
              </Box>
              <EditLink />
            </Box>

            <ReviewRow labelKey="FreeCancelDeadlineLabel" value={ROOM_DATA.freeCancelDeadline} />
            <ReviewRow labelKey="LateCancelFeeLabel" value={ROOM_DATA.lateCancelFee} />

            {YES_NO_PAIRS.map((pair, i) => (
              <Box key={i} sx={{ display: "flex", gap: 3, padding: "16px 0", borderBottom: "1px solid #E0E0E0" }}>
                <Box sx={{ flex: 1 }}>
                  <Typography sx={rowLabelSx}>{t(pair[0].labelKey)}</Typography>
                  <Typography sx={rowValueSx}>{pair[0].value}</Typography>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography sx={rowLabelSx}>{t(pair[1].labelKey)}</Typography>
                  <Typography sx={rowValueSx}>{pair[1].value}</Typography>
                </Box>
                <EditLink />
              </Box>
            ))}

            <Box sx={{ padding: "16px 0" }}>
              <Typography sx={rowLabelSx}>{t('PromotionQuestionLabel')}</Typography>
              <Typography sx={rowValueSx}>{PROMOTION_DATA}</Typography>
              <EditLink />
            </Box>
          </Box>

          <Typography sx={{ fontSize: isMobile ? "12px" : "13px", color: "#999", mt: 3 }}>
            {t('ConfirmBeforeSubmitNote')}
          </Typography>

          {/* Bottom actions */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
              mt: 4,
            }}
          >
            <Button
              onClick={() => navigate("/hotel/onboarding")}
              sx={{
                color: "#666",
                textTransform: "none",
                fontSize: isMobile ? "14px" : "16px",
                textDecoration: "underline",
              }}
            >
              {t('SaveAndLeave')}
            </Button>
            <Button
              variant="contained"
              onClick={() => navigate("/hotel/add/submit")}
              sx={{
                backgroundColor: "#31BACD",
                color: "#fff",
                borderRadius: "10px",
                textTransform: "none",
                fontSize: isMobile ? "14px" : "16px",
                padding: "10px 32px",
                "&:hover": { opacity: 0.85, backgroundColor: "#31BACD" },
              }}
            >
              {t('NextStep')}
            </Button>
          </Box>
        </Box>
      </div>
      <Footer />
    </div>
  );
};

export default HotelAdd_YOverview;
